module.exports = __webpack_public_path__ + "static/media/property-managers-1.e70a44a8.svg";